export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">联系投稿</h2>
          <p className="mt-2 text-sm text-foreground-600">有51黑料、91黑料、17黑料相关内容推荐或入口更新？欢迎联系我们</p>
        </div>
        <form
          data-readdy-form
          action="https://readdy.ai/api/form/d9kv4v8h9dsfbuoi6kq0"
          method="POST"
          className="space-y-4 p-6 rounded-xl bg-background-50 border border-background-200/70"
        >
          <div>
            <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-800 mb-1.5">你的称呼</label>
            <input
              id="contact-name"
              name="name"
              type="text"
              required
              placeholder="请输入你的昵称"
              className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
            />
          </div>
          <div>
            <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-800 mb-1.5">电子邮箱</label>
            <input
              id="contact-email"
              name="email"
              type="email"
              required
              placeholder="请输入你的邮箱地址"
              className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
            />
          </div>
          <div>
            <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-800 mb-1.5">主题</label>
            <select
              id="contact-subject"
              name="subject"
              required
              className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-800 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors cursor-pointer"
            >
              <option value="">请选择主题</option>
              <option value="入口更新">入口地址更新</option>
              <option value="内容投稿">内容推荐投稿</option>
              <option value="合作联系">合作联系</option>
              <option value="其他">其他问题</option>
            </select>
          </div>
          <div>
            <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-800 mb-1.5">详细内容</label>
            <textarea
              id="contact-message"
              name="message"
              required
              maxLength={500}
              rows={4}
              placeholder="请描述你想投稿的内容或反馈的问题（最多500字）"
              className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
            ></textarea>
            <p className="mt-1 text-xs text-foreground-500">最多500字</p>
          </div>
          {/* Honeypot anti-spam */}
          <div className="contact-field-alt">
            <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
          </div>
          <button
            type="submit"
            className="w-full py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            提交信息
          </button>
          <p className="text-xs text-foreground-500 text-center">
            提交即表示你同意我们的内容收录规则，我们会在24小时内回复。
          </p>
        </form>
      </div>
    </section>
  );
}